const React = require('react');


class GoToTop extends React.Component {
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      document.getElementById('go_top').style.opacity = 1;
    } else {
      document.getElementById('go_top').style.opacity = 0;
    }
  }

  render() {
    return (
      <a href="#" className="scroll-top" aria-label="Ir arriba" id="go_top">
        <svg className="svg" width="16" height="12" viewBox="0 0 12.218000411987305 16" xmlns="http://www.w3.org/2000/svg">
          <path d="M 14.109 6.981 L 1.978 6.981 L 5.642 3.316 L 4.218 1.891 L -1.891 8 L 4.218 14.109 L 5.642 12.685 L 1.978 9.019 L 14.109 9.019" transform="matrix(0, 1, -1, 0, 14.109016, 1.891001)" />
        </svg>
      </a>
    );
  }
}

module.exports = GoToTop;
